import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const ConditionalTooltip = props => {
  const { name, containerClass, tooltipPlacement } = props;

  const ref = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (ref && ref.current) {
      const textElement = ref?.current;
      if (textElement.scrollWidth > textElement?.offsetWidth) {
        setShowTooltip(true);
      }
    }
  }, [name]);

  return (
    <ConditionalWrapper
      type="wrapperAsElement"
      wrapper={<Tooltip tooltip={name} placement={tooltipPlacement} />}
      condition={showTooltip}
    >
      <div className={containerClass} ref={ref} dir="auto">
        {name}
      </div>
    </ConditionalWrapper>
  );
};
export default ConditionalTooltip;
